export const getOptions = (element) => {
  let type = "carousel";

  const defaults = {
    "data-sortType": "recent",
    "data-mediaType": "image",
  };

  const getValOrDefault = (key) => {
    key = key.toLowerCase();
    if (
      element.attributes[key] &&
      element.attributes[key].value !== undefined
    ) {
      return element.getAttribute(key);
    } else {
      return defaults[key];
    }
  };

  return {
    type: type,
    categoryId: element.getAttribute("data-categoryid"),
    sortType: getValOrDefault("data-sortType"),
    mediaType: getValOrDefault("data-mediaType"),
    headline: element.getAttribute("data-headline"),
    description: getValOrDefault("data-description"),
    testApiUrl: element.getAttribute("data-testapiurl"),
    ctaText: getValOrDefault("data-ctaText"),
    ctaRef: getValOrDefault("data-ctaRef"),
    editorial: element.hasAttribute("data-editorial"),
  };
};
